import React from 'react';
import {FormattedMessage} from 'react-intl';
import styled from 'styled-components';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import {InputFieldWithValidation} from '../../../../../common/InputFieldWithValidation';
import formMessages from '../../../../../../intl/claims/formMessages';
import {
    FORM_FIELD_DEALER_REMARKS,
    FORM_FIELD_PROBLEM_DESCRIPTION,
    FORM_FIELD_TAKING_BACK,
    FORM_LABEL_DEALER_REMARKS,
    FORM_LABEL_PROBLEM_DESCRIPTION,
    FORM_LABEL_TAKING_BACK,
} from '../../../../../../constants/formConstants';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const StockDeadClaimSection = (props) => {
    const {readOnly, userRights, reqFields} = props;

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...formMessages.PROBLEM_DESCRIPTION_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row pb-2">
                    <div className="col-xl-4 col-lg-6">
                        <InputFieldWithValidation label={formMessages[FORM_LABEL_TAKING_BACK]}
                                                  field={FORM_FIELD_TAKING_BACK}
                                                  maxLength={15}
                                                  isDisabled={!userRights.canEditProblemDesc || readOnly}
                                                  isRequired={reqFields.includes(FORM_FIELD_TAKING_BACK)}
                                                  isSmall/>
                    </div>
                </div>
                <div className="form-row pb-2">
                    <div className="col-12">
                        <TextareaFieldWithValidation label={formMessages[FORM_LABEL_DEALER_REMARKS]}
                                                     field={FORM_FIELD_DEALER_REMARKS}
                                                     isDisabled={!userRights.canEditProblemDescText || readOnly}
                                                     rows={3}/>
                    </div>
                </div>
                <div className="form-row pb-2">
                    <div className="col-12">
                        <TextareaFieldWithValidation label={formMessages[FORM_LABEL_PROBLEM_DESCRIPTION]}
                                                     field={FORM_FIELD_PROBLEM_DESCRIPTION}
                                                     isDisabled={!userRights.canEditProblemDescText || readOnly}
                                                     rows={6}
                                                     isRequired={reqFields.includes(FORM_FIELD_PROBLEM_DESCRIPTION)}/>
                    </div>
                </div>
            </StyledDiv>
        </>
    )
}

export default (StockDeadClaimSection);
